var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.99975,81.99975 C63.48775,81.99975 62.97675,81.80475 62.58575,81.41375 L30.58575,49.41375 C29.80475,48.63275 29.80475,47.36675 30.58575,46.58575 L62.58575,14.58575 C63.36675,13.80475 64.63275,13.80475 65.41375,14.58575 C66.19475,15.36675 66.19475,16.63275 65.41375,17.41375 L34.82875,47.99975 L65.41375,78.58575 C66.19475,79.36675 66.19475,80.63275 65.41375,81.41375 C65.02275,81.80475 64.51175,81.99975 63.99975,81.99975",
    fill: "#000000",
    fillRule: "evenodd"
  })));
};
export default SvgChevronLeft;